// Use direct backend URL for maintenance check (not proxied)
const MAINTENANCE_API_URL = import.meta.env.VITE_MAINTENANCE_API_URL || 'https://backend.fireboat-sa.com';

export interface MaintenanceStatus {
  maintenance_mode: boolean;
  message: {
    ar: string;
    en: string;
  };
}

class MaintenanceService {
  /**
   * Check if the site is in maintenance mode
   */
  async checkMaintenance(): Promise<MaintenanceStatus> {
    try {
      const url = `${MAINTENANCE_API_URL}/wp-json/sbb/v1/maintenance`;
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error('Failed to fetch maintenance status');
      }
      
      const data = await response.json();
      
      if (data?.success && data?.data) {
        return data.data;
      }
      
      // Default: not in maintenance
      return {
        maintenance_mode: false,
        message: {
          ar: '',
          en: ''
        }
      };
    } catch {
      // On error, assume not in maintenance to allow access
      return {
        maintenance_mode: false,
        message: {
          ar: '',
          en: ''
        }
      };
    }
  }
}

export default new MaintenanceService();
